import { startLoadingList, stopLoadingList } from '../../common/hoc/withLoaingList';
import { fetchLastPayoutDate, fetchPayoutsReport, fetchDailyPayroll } from '../../main/reports/actions';

export const fetchPayoutReportForShops = shops => (dispatch) => {
  dispatch(startLoadingList());
  return Promise.all(shops.map(shop => Promise.all([
    dispatch(fetchPayoutsReport(shop.id)),
    dispatch(fetchLastPayoutDate(shop.id)),
  ])))
    .then((res) => {
      dispatch(stopLoadingList());
      return res;
    })
    .catch((err) => {
      dispatch(stopLoadingList());
      return err;
    });
};

export const fetchDailyPayrollReportForShops = shops => (dispatch) => {
  dispatch(startLoadingList());
  return Promise.all(shops.map(shop => dispatch(fetchDailyPayroll(shop.id))))
    .then((res) => {
      dispatch(stopLoadingList());
      return res;
    })
    .catch((err) => {
      dispatch(stopLoadingList());
      return err;
    });
};
